import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { getInitialLoadIcons } from 'src/styles/font';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

import { HambugerMenuContainer } from '../hamburgerMenu/HamburgerMenuStyle';

export const ProfileMenuContainer = styled.div`
  ${HambugerMenuContainer};
  width: 288px;
  right: 10%;
`;

export const ProfileMenuHeader = styled.div`
  color: ${colors.AccentInfoPopupDescriptionMobileColor};
  text-align: left;
  padding: 15.5px 0px;
  ${flex('row', 'flex-start')};
  cursor: pointer;
  background: ${colors.ProfileHeaderBg};
`;

export const ProfileMenuFooter = styled.div`
  text-align: center;
  padding: 22px 0px 22px;
  border-top: 2px solid ${colors.PrimaryWhiteColorAlpha10};
`;

export const container = css`
  position: relative;
  border-radius: 4px;
`;

export const UserProfile = styled.button`
  background: none;
  border: none;
  color: ${colors.PrimaryWhiteColorAlpha50};
  ${getInitialLoadIcons(InitialLoadIconsSet.USER_PROFILE)};
  &:before {
    font-size: 15px;
  }
  font-size: 18px;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  cursor: pointer;
  background: ${colors.PrimaryWhiteColorAlpha10};
  margin: 0 15px;
`;

export const ViewAllButton = styled.button`
  ${flex()};
  background: none;
  border: none;
  color: ${colors.white};
  ${getInitialLoadIcons(InitialLoadIconsSet.VIEW_ALL)};
  &:before {
    color: ${colors.Lavender};
  }
  font-size: 18px;
  height: 36px;
  width: 36px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 15px;
`;
